/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as ordersSlice from './ordersSlice';

export default function* watchOrdersSaga() {
 yield takeLatest(ordersSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(ordersSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(ordersSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(ordersSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(ordersSlice.deleteItemsStart.type, commonSagas.deleteItems);
 yield takeLatest(ordersSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  ordersSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  ordersSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  ordersSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  ordersSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  ordersSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
}
